module.exports = __webpack_public_path__ + "assets/img/one-north Business Park.e585e4c3.jpg";